module.exports = __webpack_public_path__ + "media/images/ui__arrowUpInactive-b8b69acf1fcaaef9971739d057f14fe7.png";